import { DocCenterRequestModal } from 'document-center-mfe'
import getMFEConfig from 'helpers/getMFEConfig'
import { getBrandRefreshPhase } from 'helpers/getBrandRefreshPhase'
import { WritableAtom, useAtom, useAtomValue } from 'jotai'
import { jotaiStore } from 'store'
import { ModalState } from 'store/atoms/typings'
import { triggerAnalyticsEvent } from 'syf-js-utilities'
import { useNavigate } from 'react-router-dom'
import routes from 'const/routes'
import useOpenStatementsMFE from 'hooks/useOpenStatementsMFE'
import { modalStatusAtom, selectedAccountAtom } from '../../store/atoms'

const RequestPastStatementsModal = () => {
  const selectedAccount = useAtomValue(selectedAccountAtom)
  const mfeConfig = getMFEConfig('mfe')
  const brandRefreshPhase = getBrandRefreshPhase()
  const navigate = useNavigate()
  const openStatementsMFE = useOpenStatementsMFE()
  const [, updateModalStatus] = useAtom(modalStatusAtom)

  return (
    <DocCenterRequestModal
      triggerAnalyticsEvent={triggerAnalyticsEvent}
      config={mfeConfig}
      featureFlags={{ brandRefreshPhase }}
      accountId={selectedAccount}
      atoms={{
        modalStatusAtom: modalStatusAtom as unknown as WritableAtom<
          ModalState,
          [modalId: string, modalTriggerId?: string],
          void
        >
      }}
      store={jotaiStore}
      handleDocCenterClick={() => {
        updateModalStatus('')
        navigate(routes.DOCUMENT_CENTER)
      }}
      handleStatementsClick={() => {
        updateModalStatus('')
        openStatementsMFE()
      }}
    />
  )
}

export default RequestPastStatementsModal
